<ng-container [ngSwitch]="isLoginPage">
  <ng-container *ngSwitchCase="false">
    <ng-container *ngTemplateOutlet="mainPage"></ng-container>
    <div *ngIf="auth.user | async; then authenticated; else guest"></div>
    <ng-template #guest>
      <monorepo-menu-list-items
        [menuItem]="mobileMenuGuestUser"
        [themeColor]="themeColors"
      ></monorepo-menu-list-items>
    </ng-template>
    <ng-template #authenticated>
      <monorepo-menu-list-items
        [menuItem]="mobileMenuItems"
        [themeColor]="themeColors"
      ></monorepo-menu-list-items>
    </ng-template>
  </ng-container>
  <ng-container *ngSwitchCase="true">
    <router-outlet></router-outlet>
  </ng-container>
</ng-container>

<ng-template #mainPage>
  <ng-container [ngSwitch]="isDashboard">
    <ng-container *ngSwitchCase="true">
      <ng-container *ngTemplateOutlet="DashBoardTemplate"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="false">
      <signgaze-header-container></signgaze-header-container>
      <div
        class="home-view-container"
        [ngClass]="{ 'mt-0-xs': isShowListings }"
      >
        <router-outlet></router-outlet>
      </div>
      <signgaze-footer-container
        *ngIf="isShowFooter"
      ></signgaze-footer-container>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #DashBoardTemplate>
  <div class="ui secondary no shadow segment main-dashboard">
    <signgaze-header-container></signgaze-header-container>
    <div class="ui equal grid mt-0 full height">
      <div class="row pad-xs">
        <div class="three-wide computer-only column">
          <div class="ui segment no border dashboard-sidebar">
            <div class="ui secondary vertical menu">
              <a
                class="item"
                [routerLink]="[profileItem.link]"
                routerLinkActive="active"
                *ngFor="let profileItem of profileItems"
              >
                <i
                  class="left floated {{
                    profileItem.icon
                  }} pure-hidden-md icon"
                ></i>
                <span>{{ profileItem.name }}</span>
              </a>

              <div class="ui divider"></div>
              <h3 class="ui header">Help</h3>
              <a
                class="item"
                [routerLink]="[helpItem.link]"
                routerLinkActive="active"
                *ngFor="let helpItem of helpItems"
              >
                <i
                  class="{{ helpItem.icon }} left floated pure-hidden-md icon"
                ></i>
                <span>{{ helpItem.name }}</span>
              </a>
            </div>
            <div
              class="
                ui
                secondary
                no
                border
                center
                aligned
                refer-segment
                segment
              "
            >
              <h4 class="primary text fw-100 m-0">Refer a friend!</h4>
              <h5 class="primary text fw-100 mt-0">And get awesome rewards</h5>
              <img
                class="ui small centered image"
                src="assets/images/refer-illustration.svg"
              />
            </div>
          </div>
        </div>
        <div
          class="
            sixteen-wide-mobile sixteen-wide-tablet
            thirteen-wide-computer
            pd-left
            column
          "
        >
          <div class="dashboard-view-container scroll-transparent">
            <router-outlet *ngIf="online$ | async"></router-outlet>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
